import isString from 'lodash/isString';

export const STORED_RADIO = 'sportsbook-radio';

export const parseJSON = (str) => {
  try {
    if (isString(str) && str.length) {
      const obj = JSON.parse(str);

      if (obj && typeof obj === 'object' && obj !== null) {
        return obj;
      }
    }
  } catch (e) {
    console.error('ERROR_PARSE_STRING_TO_VALID_JSON', e);
  }

  return undefined;
};

export const removeFromLocalStorage = () => {
  try {
    localStorage.removeItem(STORED_RADIO);
  } catch (e) {
    console.error('ERROR_REMOVE_FROM_LOCAL_STORAGE', e);
  }
};

export const readFromLocalStorage = () => {
  try {
    return parseJSON(localStorage.getItem(STORED_RADIO));
  } catch (e) {
    console.error('ERROR_READ_FROM_LOCAL_STORAGE', e);
  }

  return undefined;
};

export const writeToLocalStorage = (data) => {
  try {
    localStorage.setItem(STORED_RADIO, JSON.stringify(data));
  } catch (e) {
    console.error('ERROR_WRITE_TO_LOCAL_STORAGE', e);
  }
};
